import ResponsiveAppBar from "../../../layouts/navbar";

import { ProductTypes } from "./components/productTypes";
import { Categories } from "./components/Categories";
import { CustomizeBanner } from "./components/FeaturedProducts";
import { LatestProducts } from "./components/LatestProduct";
import { Testimonials } from "./components/Testimonials";
import { Collaboration } from "./components/Collaboration";
import { Service } from "./components/Service";
import { Banner } from "./components/Banner";
import { Footer } from "../../../layouts/footer";
import { SpecialProducts } from "./components/SpecialProducts";
import { useEffect } from "react";
import { useMediaQuery } from "@mui/material";

export const LandingPage = () => {
    const isMobileScreen = useMediaQuery("(max-width:765px)");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    localStorage.removeItem("order_uuid");
    localStorage.removeItem("product_id");
    localStorage.removeItem("orderDetails");
    localStorage.removeItem("offer_id");
    localStorage.removeItem("custom_product_id");
    localStorage.removeItem("custom_order_uuid");
    localStorage.removeItem("Category_code");
  }, []);
  return (
    <>
      <div id="wrapper">
        <ResponsiveAppBar />

        <ProductTypes />
        <Banner />
        <SpecialProducts />
        {/* <Categories /> */}
        {/* commented on 12/02  */}
        <CustomizeBanner />
        {/* <LatestProducts /> */}
        <Testimonials />

       {!isMobileScreen&& <Collaboration />}
        <Service />
      </div>
      <Footer />
    </>
  );
};
